import React, { useEffect, useState } from "react";
import get from "lodash/get";
import Modal from "../../../parts/modal-new";
import useFormValidation from "../../../hooks/useFormValidation";

const ChangeEmailModal = ({ locals }) => {
  const { activeUser } = locals;
  const activeUserEmail = get(activeUser, "email", "");
  const formId = "form-change-email";
  const isValid = useFormValidation(formId);

  return (
    <Modal title={"Change Email"} className={"change-email-wrapper"}>
      <div className="body">
        <form
          id={formId}
          action="/actions/user/reset-email"
          method="POST"
          data-noreset
        >
          <label>New Email</label>
          <input
            required
            type="text"
            name="email"
            className="text-input"
            defaultValue={activeUserEmail}
            sz="large"
          />

          <label>Current Password</label>
          <input
            required
            type="password"
            name="currentPassword"
            className="text-input"
            sz="large"
          />
        </form>
      </div>
      <footer>
        <a
          role="button"
          data-button-type="secondary"
          data-action="cancel"
          href="/actions/refresh?modal="
        >
          Cancel
        </a>
        <button
          data-button-type="primary"
          form="form-change-email"
          type="submit"
          disabled={!isValid}
        >
          Save
        </button>
      </footer>
    </Modal>
  );
};

export default ChangeEmailModal;
